export default __webpack_public_path__ + "static/media/sierra.92cb0c76.png";